import { ReactElement, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  CardContainer, EnergyConsumptionSpreadsheetContainer,
  TitleContainer,
} from './styles';
import { SpreadsheetExport } from './ExportSpreadsheet';
import { SpreadsheetInsert } from './InsertSpreadsheet';
import { useTranslation } from 'react-i18next';
import { ColumnsIcon } from 'icons';
import { NewBreadcrumb } from 'components/NewBreadcrumb';
import { apiCall } from '~/providers';
import { Loader } from '~/components';
import { PreFillGuide } from './components/PreFillGuide';
import { Orientation } from './components/Orientation';
import { getUserProfile } from '~/helpers/userProfile';

export function EnergyConsumptionSpreadsheet(): ReactElement {
  const [profile] = useState(getUserProfile);
  const [loading, setLoading] = useState(false);
  const [units, setUnits] = useState<{ name: string, id: number }[]>([]);
  const [clientName, setClientName] = useState<string>();
  const { clientId } = useParams<{ clientId: string }>();
  const { t } = useTranslation();

  async function fetchInfo(): Promise<void> {
    setLoading(true);
    const [responseUnits, responseClient] = await Promise.all([
      apiCall('/clients/get-units-list-basic', { CLIENT_ID: Number(clientId) }),
      apiCall('/clients/get-client-info', { CLIENT_ID: Number(clientId) })]);

    setUnits(responseUnits.list.map((item) => ({
      name: item.UNIT_NAME,
      id: item.UNIT_ID,
    })));
    setClientName(responseClient.client.NAME);

    setLoading(false);
  }

  useEffect(() => {
    if (clientId) {
      fetchInfo();
    }
  }, []);

  if (!loading && (!clientId || !clientName)) {
    return (
      <div>
        {t('clienteNaoEncontrado')}
      </div>
    );
  }

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <EnergyConsumptionSpreadsheetContainer>
      <TitleContainer>
        <ColumnsIcon size="20" />
        <h1>{t('cadastrarMetaConsumoEnergiaPorPlanilha')}</h1>
      </TitleContainer>
      <NewBreadcrumb
        items={[
          {
            text: clientName ?? '-',
            link: '/painel/clientes/listagem',
          },
          {
            text: 'Painel',
            link: profile.manageAllClients ? `/painel/clientes/editar-cliente/${clientId}` : '/painel/client-painel',
          },
          {
            text: 'Cadastrar Meta de Consumo Energia por Planilha',
            link: `/painel/clientes/editar-cliente/${clientId}/energia/cadastro-metas-planilha`,
          },
        ]}
      />
      <CardContainer>
        <Orientation
          title={t('passo1BaixarPlanilha')}
          orientations={[t('facaExportacaoContemDadosAtuais')]}
        >
          <SpreadsheetExport units={units} />
        </Orientation>
        <Orientation
          title={t('passo2InserirPlanilha')}
          orientations={[
            t('paraRealizarUploadDownloadPlanilhaExemplo'),
            t('preenchaTabelaDadosAInserir'),
          ]}
        >
          <SpreadsheetInsert />
        </Orientation>
        <h2>{t('guiadePreenchimento')}</h2>
        <PreFillGuide units={units} />
      </CardContainer>
    </EnergyConsumptionSpreadsheetContainer>
  );
}
